import { gql } from '@apollo/client'

export const DeleteRoom = gql`
    mutation DeleteRoom($roomId: ID!) {
        deleteRoom(roomId: $roomId) {
            avatar
            created
            email
            id
            invites {
                id
                issuer {
                    id
                    username
                }
                room {
                    id
                    name
                    owner {
                        id
                        username
                    }
                }
            }
            rooms {
                id
                name
                topic
                spinning
                owner {
                    id
                    username
                }
                admins {
                    id
                    username
                }
                members {
                    id
                    username
                }
            }
            roles
            storage
            updated
            username
        }
    }
`

export default DeleteRoom

